<template>
  <span class="status">
    <slot />
    <i v-if="status === 'reported' || status === true" class="success mdi mdi-check-circle" />
    <i v-else-if="status === 'partially_reported'" class="success opacity mdi mdi-check-circle" />
    <i v-else-if="status === 'discarded' || status === false" class="error el-icon-warning" />
    <i v-else-if="status === 'not_reported'" class="info mdi mdi-minus-circle" />
    <i v-else-if="status === 'not_to_be_reported'" class="mdi mdi-cancel" />
    <i v-else-if="status === 'skipped'" class="mdi mdi-skip-forward" />
  </span>
</template>

<script>
export default {
  name: 'Status',
  props: {
    status: {
      type: [Boolean, String, Number],
      default: ''
    }
  }
};
</script>

<style lang="scss">
.status {
  display: flex;
  justify-content: space-between;

  i {
    margin-top: 3px;
    font-size: 24px;
  }

  .success {
    color: $greenElliott;
  }

  .opacity {
    opacity: 0.5;
  }

  .error {
    color: $opalFlame;
  }

  .info {
    color: $andreaBlue;
  }
}
</style>
